import { RevenueSection } from "@/admin/users/RevenueSection.tsx";
import type { GQUserItem } from "@/admin/users/UsersTable.tsx";
import { ContentPane } from "@/components/ContentPane.tsx";
import { LongDate } from "@/components/l10n/DateFormat.tsx";
import { Separator } from "@/components/Separator.tsx";
import { DetailsHolder, DetailsTable } from "@/components/table/DetailsTable.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { ViewTitle } from "@/components/Title.tsx";
import { apiDatetimeToDate } from "@warrenio/api-spec/conversion";

export function UserDetailView({ item }: { item: GQUserItem }) {
    return (
        <>
            <UserDetails item={item} />
            <Separator />
            <ContentPane>
                <RevenueSection userId={item.id} createdAt={item.profile_data?.created_at} />
            </ContentPane>
        </>
    );
}

function UserDetails({ item }: { item: GQUserItem }) {
    const { id, name, profile_data } = item;

    return (
        <ContentPane className="VStack gap-4">
            <ViewTitle title={name} />

            <DetailsHolder>
                <DetailsTable>
                    <DetailsTableRow title="ID">{id}</DetailsTableRow>
                    <DetailsTableRow title="First name">{profile_data?.first_name ?? ""}</DetailsTableRow>

                    <DetailsTableRow title="Last name">{profile_data?.last_name ?? ""}</DetailsTableRow>

                    <DetailsTableRow title="Email">{profile_data?.email}</DetailsTableRow>

                    <DetailsTableRow title="Created">
                        {profile_data?.created_at ? (
                            <LongDate date={apiDatetimeToDate(profile_data.created_at)} />
                        ) : (
                            "-"
                        )}
                    </DetailsTableRow>
                </DetailsTable>
            </DetailsHolder>
        </ContentPane>
    );
}
